import { Link } from 'react-router-dom';
import {
  Container,
  Title,
  SimpleGrid,
  Card,
  Text,
  Stack,
  Group,
  Loader,
  Alert,
  Button,
  Pagination
} from '@mantine/core';
import { IconExclamationCircle, IconHeart, IconBuildingStore } from '@tabler/icons-react';
import { useState } from 'react';
import { useAuth } from '@clerk/react';
import { useApi } from '../api';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import SellerCard from '../components/sellers/SellerCard';

const PAGE_LIMIT = 24;

const FavoritesPage = () => {
  const [page, setPage] = useState(1);
  const { isSignedIn } = useAuth();

  // Newest favorite first (contract §4.9); only currently-visible sellers.
  const { data, loading, error, refetch } = useApi(
    '/api/v1/me/favorites',
    { page, limit: PAGE_LIMIT },
    { enabled: !!isSignedIn, query: { placeholderData: (prev) => prev } }
  );
  const favorites = data?.items ?? [];
  const totalPages = data ? Math.max(1, Math.ceil(data.total / data.limit)) : 1;

  return (
    <ProtectedRoute requireAuth={true}>
      <Container size="lg" py="xl">
        <Stack gap="xl">
          <Group gap="xs" align="center">
            <IconHeart size="1.5rem" color="var(--mantine-color-pink-6)" />
            <Title order={1}>My Favorites</Title>
          </Group>

          {error && (
            <Alert icon={<IconExclamationCircle size="1rem" />} color="red">
              {error.message}
            </Alert>
          )}

          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
              <Loader size="lg" />
            </div>
          ) : favorites.length === 0 ? (
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <Stack align="center" gap="md" py="xl">
                <IconHeart size={48} color="var(--mantine-color-gray-4)" />
                <Text c="dimmed" size="lg">No favorites yet</Text>
                <Text c="dimmed" size="sm">
                  Tap the heart on a princess to save her here.
                </Text>
                <Button
                  component={Link}
                  to="/princesses"
                  color="grape"
                  variant="light"
                  leftSection={<IconBuildingStore size="1rem" />}
                >
                  Browse Princesses
                </Button>
              </Stack>
            </Card>
          ) : (
            <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
              {favorites.map((seller) => (
                <SellerCard
                  key={seller.id}
                  seller={seller}
                  onFavoriteToggled={() => refetch()}
                />
              ))}
            </SimpleGrid>
          )}

          {totalPages > 1 && (
            <Group justify="center">
              <Pagination value={page} onChange={setPage} total={totalPages} />
            </Group>
          )}
        </Stack>
      </Container>
    </ProtectedRoute>
  );
};

export default FavoritesPage;
